import classNames from 'classnames';
import * as React from 'react';

import css from './BooksFacebookLoginButton.module.scss';

interface Props extends React.ComponentProps<'button'> {
  className?: string;
  disabled?: boolean;
  postable?: boolean;
  onClick?: (event: React.MouseEvent) => void;
  small?: boolean;
}

class BooksSubmitButton extends React.PureComponent<Props> {
  constructor(props: Props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
  }

  private handleClick(event: React.MouseEvent) {
    const { disabled, onClick } = this.props;
    if (disabled) {
      event.preventDefault();
      return;
    }
    if (onClick) {
      onClick(event);
    }
  }

  public render() {
    const {
      className,
      disabled,
      postable,
      children,
      small,
      ...attr
    } = this.props;
    const classes = classNames(
      css.BooksFacebookLoginButton,
      { [css.isSmall]: small },
      className,
    );

    return (
      <div className={classes}>
        <button
          {...attr}
          type={'button' as 'button'}
          className={css.BooksFacebookLoginButton__Button}
          disabled={!!disabled}
          onClick={this.handleClick}
        >
          {children}
          {postable !== undefined && !postable && (
            <span className={css.BooksFacebookLoginButton__Loading} />
          )}
        </button>
      </div>
    );
  }
}

export default BooksSubmitButton;
